import projection from '../generated/pwj215f1.json';
import { AcceptanceManifest } from '../types';
export const pwj215f1AcceptanceManifest = projection as AcceptanceManifest;
